<template lang="pug">
.ride-container(:class="[`type-${type}`]")
  .ride-body
  img.img.copy(
    src="https://m.hellobike.com/resource/helloyun/15979/JEW55Wmpnf.png",
    @click="download"
  )
  .btn.flex-mid.copy(@click="goRide") 继续付费骑行
  .tip *文山市不参与此活动

</template>
<script>
import { wechatScanUrlMetric } from '@/api/wechat-mp-card';
import Clipboard from 'clipboard';
import { isPreRender } from '../../utils';
import { UBTUtils } from '../../utils/ubt';
import { BIKE_TYPE } from './const';
import config from '../../const/config';
import { clientSDK } from '../../utils/wisdomSDK';


export default {
  components: {},
  data() {
    return {
      type: null,
      bikeType: BIKE_TYPE(),
      command: null,
      clipboard: null,
      urlParam: null,

    };
  },
  created() {
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      return;
    }
    this.init();
  },
  mounted() {
    wechatScanUrlMetric({
      url: window.location.href,
      reportTime: Date.now(),
    })
      .catch(() => {})
      .then(() => {});
  },
  beforeDestroy() {
    const { openId, n, u } = this.$route.query;
    const { bikeType } = this;

    this.type = n || u ? bikeType.n : bikeType.e;
    if (this.type === bikeType.n) {
      UBTUtils.pageViewOut({
        pageId: 'wxkl2_dc',
        categoryId: 'platform',
        businessInfo: {
          openid: openId,
        },
      });
    }
    if (this.type === bikeType.e) {
      UBTUtils.pageViewOut({
        pageId: 'wxkl2_zlc',
        categoryId: 'platform',
        businessInfo: {
          openid: openId,
        },
      });
    }
  },
  destroyed() {
    if (this.clipboard) {
      this.clipboard.destroy();
    }
  },

  methods: {
    init() {
      const { openId, n, u } = this.$route.query;
      const { bikeType } = this;

      if (openId) {
        this.openId = openId;
      }
      this.type = (n || u) ? bikeType.n : bikeType.e;
      if (this.type === bikeType.n) {
        UBTUtils.pageView({
          pageId: 'wxkl2_dc',
          categoryId: 'platform',
          businessInfo: {
            openid: this.openId,
          },
        });
      }
      if (this.type === bikeType.e) {
        UBTUtils.pageView({
          pageId: 'wxkl2_zlc',
          categoryId: 'platform',
          businessInfo: {
            openid: this.openId,
          },
        });
      }

      this.fillUbt();
      const param = this.$route.query;
      this.urlParam = Object.keys(param).map((key) => `${key}=${param[key]}`).join('&');
      this.getData();
    },
    getData() {
      clientSDK().get('wechat_control', null).then((res) => {
        if (res) {
          const command = res[`command_${this.type}`];
          this.command = command;
          if (command && Clipboard) {
            this.clipboard = new Clipboard('.copy', {
              text() {
                return command;
              },
            });
          }
        }
      });
    },
    download() {
      const bike = this.type === this.bikeType.n;
      const evbike = this.type === this.bikeType.e;
      if (bike) {
        UBTUtils.clickButton({
          pageId: 'wxkl2_dc',
          buttonName: 'dc_dl',
          categoryId: 'platform',
          businessInfo: {
            openid: this.openId,
          },
        });
      }
      if (evbike) {
        UBTUtils.clickButton({
          pageId: 'wxkl2_zlc',
          buttonName: 'dl_app',
          categoryId: 'platform',
          businessInfo: {
            openid: this.openId,
          },
        });
      }
      this.fillUbt();
      setTimeout(() => {
        if (bike) {
          window.location.href = 'https://at.umtrack.com/onelink/jCCaqe';
        }
        if (evbike) {
          window.location.href = 'https://at.umtrack.com/onelink/jK5TXb';
        }
      });
    },
    goRide() {
      if (this.type === this.bikeType.n) {
        UBTUtils.clickButton({
          pageId: 'wxkl2_dc',
          buttonName: 'goon_dc',
          categoryId: 'platform',
          businessInfo: {
            openid: this.openId,
          },
        });
      }

      if (this.type === this.bikeType.e) {
        UBTUtils.clickButton({
          pageId: 'wxkl2_zlc',
          buttonName: 'goon_zlc',
          categoryId: 'platform',
          businessInfo: {
            openid: this.openId,
          },
        });
      }
      this.fillUbt();
      const { urlParam, type } = this;
      const query = `?type=${type}&${urlParam}`;
      setTimeout(() => {
        window.location.href = `https://m.hellobike.com/AppPlatformH5/${config.env === 'pro' ? '' : `${config.env}/`}latest/index.html#/wechat-control/ride${query}`;
      });
    },
    fillUbt() {
      UBTUtils.moduleExpose({
        pageId: 'wxkl2_dc',
        categoryId: 'platform',
        moduleId: 'wxkl2_dc_btn',
        contentId: 'wxkl_zzyexpose',
        exposureTimes: 1,
        businessInfo: {
        },
      });
      UBTUtils.moduleExpose({
        pageId: 'wxkl2_dc',
        categoryId: 'platform',
        moduleId: 'wxkl2_dc_btn_count',
        contentId: 'wxkl_zzyexpose',
        exposureTimes: 1,
        businessInfo: {
        },
      });
      UBTUtils.moduleExpose({
        pageId: 'wxkl2_dc',
        categoryId: 'platform',
        moduleId: 'wxkl2_dc_title',
        contentId: 'wxkl_zzyexpose',
        exposureTimes: 1,
        businessInfo: {
        },
      });
      UBTUtils.moduleExpose({
        pageId: 'wxkl2_dc',
        categoryId: 'platform',
        moduleId: 'wxkl2_dc_text',
        contentId: 'wxkl_zzyexpose',
        exposureTimes: 1,
        businessInfo: {
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.ride-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  min-height: 100vh;
  background-color: #fff;
  background-image: url(https://m.hellobike.com/resource/helloyun/15979/fvEzsMUVYN.png);
  background-size: 100%;
  background-repeat: no-repeat;
  padding-top: 3.95rem;

  &.type-2 {
    background-image: url(https://m.hellobike.com/resource/helloyun/15979/AbrxuUGLrl.png);
  }

  .img {
    width: 3.19rem;
    height: 0.7rem;
    margin-bottom: 0.38rem;
  }

  .btn {
    width: 3.19rem;
    height: 0.64rem;
    background: #fff2ec;
    border-radius: 0.32rem;
    border: 0.01rem solid #ffc4a7;
    font-size: 0.2rem;
    font-weight: 500;
    color: #f00;
    line-height: 0.28rem;
    margin-bottom: 1.2rem;
  }

  .tip {
    font-size: 0.14rem;
    color: #a4a4a4;
    line-height: 0.2rem;
  }
}
</style>
